export const SESSION_EXPIRED_EVENT = 'sigcom:session-expired'
export const SESSION_RENEWED_EVENT = 'sigcom:session-renewed'
